import { type FC, useState } from "react";
import { RequestOutreachStatus, useRequestOutreach } from "../../../hooks/useRequestOutreach";
import type { ShiftRequest } from "../../../utils/models";
import { NormalizedRequestApprovalDialog } from "../../approvalDialogs/RequestsApproval/NormalizedRequestApprovalDialog";
import { RequestOutreachPopup } from "./RequestOutreachPopup";

/** Mounted only while open, so a list of cards never builds outreach nobody looks at. */
export const OutreachPopupContainer: FC<{ request: ShiftRequest; onClose: () => void }> = ({ request, onClose }) => {
	const result = useRequestOutreach(request);
	const [reviewing, setReviewing] = useState(false);
	if (reviewing) return <NormalizedRequestApprovalDialog open request={request} onClose={onClose} />;
	if (result.status === RequestOutreachStatus.Unavailable) return null;
	return <RequestOutreachPopup open onClose={onClose} onReview={() => setReviewing(true)} outreach={result.outreach} actions={result.actions} />;
};
